import React, { ReactNode } from 'react';
import { Divider, Grid, Stack, Typography } from '@mui/material';

interface FormSectionProps {
  title: string;
  description?: string;
  children: ReactNode;
}

const FormSection = ({ title, description, children }: FormSectionProps) => {
  return (
    <Stack spacing={2.5}>
      <Stack spacing={0.5}>
        <Typography variant="h6">{title}</Typography>
        {description ? (
          <Typography variant="body2" color="text.secondary">
            {description}
          </Typography>
        ) : null}
      </Stack>
      <Grid container spacing={3}>
        {children}
      </Grid>
      <Divider />
    </Stack>
  );
};

export default FormSection;
